export default function BlogListHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            The Dinari Designs Knowledge Hub
          </h1>
          <p className="text-2xl text-teal-600 font-semibold mb-8">
            Technical Insights for the Vancouver Construction Industry
          </p>
          <div className="text-lg text-gray-700 leading-relaxed space-y-4">
            <p>
              Welcome to our resource center for developers, project managers, and site supervisors. From optimizing AutoCAD workflows to the strategic advantages of outsourcing technical detailing, our goal is to provide the intelligence you need to build faster, leaner, and more accurately in the BC market.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
